import { render, staticRenderFns } from "./ImgPool.vue?vue&type=template&id=137f982c&scoped=true"
import script from "./ImgPool.vue?vue&type=script&lang=js"
export * from "./ImgPool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137f982c",
  null
  
)

export default component.exports